
const listeners = {};

let channel = null;

if ("BroadcastChannel" in window) {
    channel = new BroadcastChannel("pretzu-events");

    channel.onmessage = (event) => {
        const { type, payload } = event.data;
        dispatch(type, payload);
    };
}

function dispatch(type, payload) {
    if (!listeners[type]) return;

    listeners[type].forEach((callback) => {
        callback(payload);
    });
}

export const emit = (type, payload = null) => {
    // misma pestaña
    dispatch(type, payload);

    // otras pestañas
    if (channel) {
        channel.postMessage({ type, payload });
    } else {
        localStorage.setItem(
            "pretzu-event",
            JSON.stringify({ type, payload, ts: Date.now() })
        );
    }
};

export const on = (type, callback) => {
    if (!listeners[type]) {
        listeners[type] = [];
    }

    listeners[type].push(callback);

    return () => {
        listeners[type] = listeners[type].filter((cb) => cb !== callback);
    };
};

window.addEventListener("storage", (event) => {
    if (event.key === "pretzu-event") {
        const data = JSON.parse(event.newValue);
        dispatch(data.type, data.payload);
    }
});